// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientPortalAccess-module__container___rsAQA {
  padding: 27px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.PatientPortalAccess-module__button___ywqqO {
  width: auto;
  align-self: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/fragments/PatientPortalAccess/PatientPortalAccess.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  padding: 27px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.button {\n  width: auto;\n  align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PatientPortalAccess-module__container___rsAQA`,
	"button": `PatientPortalAccess-module__button___ywqqO`
};
module.exports = ___CSS_LOADER_EXPORT___;
